// extracted by mini-css-extract-plugin
export default {"meinian-style-analysis":"index_meinian-style-analysis__v2JfM"};